import * as React from 'react';
import styled from 'styled-components';

import { useProgressiveImage } from '../../../utils/hooks/useProgressiveImage';

export const TileGallery: React.FC<{
  className?: string;
  image?: string | undefined;
  onClick: () => void;
}> = ({ className, image, onClick }) => {
  const { loaded } = useProgressiveImage({
    url: image,
  });
  return (
    <StyledGalleryTile className={className} onClick={onClick}>
      <img
        alt="bilde fra galleri"
        data-lazy-url={image}
        className={loaded ? 'image-loaded' : ''}
        src={loaded ? image : ''}
      />
    </StyledGalleryTile>
  );
};

const StyledGalleryTile = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.tile.default.background};

  img {
    transition: opacity 0.15s ease-in-out;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    vertical-align: middle;

    &.image-loaded {
      opacity: 1;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;
